import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./Layout/Layout";

import { Spinner } from "./Components/Spinner/Spinner";
import ProtectedRoute from "./ProtectedRoute/ProtectedRoute";
import { AuthProvider } from "./AuthProvider/AuthProvider";
import { AppProvider } from "./AppProvider/AppProvider"

const Login          = lazy(() => import("./Pages/Login/Login"));
const Home           = lazy(() => import("./Pages/Home/Home"));
const ManageUsers    = lazy(() => import("./Pages/ManageUsers/ManageUsers"));
const FormBuilder    = lazy(() => import("./Pages/FormBuilder/FormBuilder"));
const EditForm       = lazy(() => import("./Pages/EditForm/EditForm"));
const FillForm       = lazy(() => import("./Pages/FillForm/FillForm"));
const Records        = lazy(() => import("./Pages/Records/Records"));
const ManageClients  = lazy(() => import("./Pages/ManageClients/ManageClients"));
const ManageProjects = lazy(() => import("./Pages/ManageProjects/ManageProjects"));
const NotFound       = lazy(() => import("./Pages/NotFound/NotFound"));
const CollectStyles  = lazy(() => import("./Pages/CollectStyles/CollectStyles"));
const Unauthorized   = lazy(() => import("./Pages/Unauthorized/Unauthorized"));


export default function App() {
  return (
    <Router>
      <AuthProvider>
        <AppProvider>
          <Suspense fallback={<Spinner active={true}/>}>
            <Spinner/>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route path="login" element={<Login />} />
                <Route path="*" element={<NotFound />} />

                {/* All users with login */}
                <Route index element={<ProtectedRoute><Home /></ProtectedRoute>} />
                <Route path="records" element={<ProtectedRoute><Records /></ProtectedRoute>} />
                <Route path="new-records" element={<ProtectedRoute><FillForm /></ProtectedRoute>} />
                <Route path="unauthorized" element={<Unauthorized />} />
                {/* All users with login */}

                {/* Only admin */}
                <Route path="admin/users" element={<ProtectedRoute requiredRole="admin"><ManageUsers/></ProtectedRoute>} />
                <Route path="form-builder" element={<ProtectedRoute requiredRole="admin"><FormBuilder/></ProtectedRoute>} />
                <Route path="edit-form" element={<ProtectedRoute requiredRole="admin"><EditForm/></ProtectedRoute>} />
                <Route path="clients" element={<ProtectedRoute requiredRole="admin"><ManageClients/></ProtectedRoute>} />
                <Route path="projects" element={<ProtectedRoute requiredRole="admin"><ManageProjects/></ProtectedRoute>} />
                <Route path="styles" element={<ProtectedRoute requiredRole="admin"><CollectStyles/></ProtectedRoute>} />
                {/* Only admin */}
              </Route>
            </Routes>
          </Suspense>
        </AppProvider>
      </AuthProvider>
    </Router>
  );
}
